import { ReactNode } from 'react';
import { AppFormRangeItemMode } from 'types';
import { AppFormItem, AppFormItemProps } from '../AppFormItem/AppFormItem';

export type AppFormRangeItemValues = Pick<AppFormItemProps, 'name' | 'rules' | 'disabled'> & {
    label?: string;
    additionalText: string;
    accessibilityLabel?: string;
};

export type AppFormRangeItemProps = AppFormItemProps & {
    mode: AppFormRangeItemMode;
    startValues: AppFormRangeItemValues;
    finishValues: AppFormRangeItemValues;
    children: ReactNode;
};

export const AppFormRangeItem = ({
    mode,
    startValues,
    finishValues,
    children,
    ...props
}: AppFormRangeItemProps) => {
    const {
        label: startLabel,
        additionalText: startAdditionalText,
        name: startName,
        rules: startRules,
        disabled: startDisabled,
    } = startValues;
    const {
        label: finishLabel,
        additionalText: finishAdditionalText,
        name: finishName,
        rules: finishRules,
        disabled: finishDisabled,
    } = finishValues;
    const isStartMode = mode === 'start';

    return (
        <AppFormItem
            label={isStartMode ? startLabel : finishLabel}
            additionalText={isStartMode ? startAdditionalText : finishAdditionalText}
            hasOptionalText
            name={isStartMode ? startName : finishName}
            rules={isStartMode ? startRules : finishRules}
            disabled={isStartMode ? startDisabled : finishDisabled}
            {...props}
        >
            {children}
        </AppFormItem>
    );
};
